import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import {
  CONSENT_CHANGE_EVENT,
  getStoredConsent,
  loadGa,
  trackPageview,
} from "@/lib/analytics";

/**
 * Loads Google Analytics once the visitor has granted consent, then sends a
 * SPA page_view on every route change. Renders nothing.
 *
 * Until consent is granted (or if VITE_GA_MEASUREMENT_ID is unset) this is inert
 * — no GA script, no cookies, no requests.
 */
const Analytics: React.FC = () => {
  const { pathname, search } = useLocation();
  const [granted, setGranted] = useState(
    () => getStoredConsent() === "granted",
  );

  // React to the banner granting/revoking consent.
  useEffect(() => {
    const onChange = () => setGranted(getStoredConsent() === "granted");
    window.addEventListener(CONSENT_CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onChange);
  }, []);

  // Inject gtag once consent is granted.
  useEffect(() => {
    if (granted) loadGa();
  }, [granted]);

  // Track pageviews (no-op until gtag is loaded).
  useEffect(() => {
    if (granted) trackPageview(pathname + search);
  }, [granted, pathname, search]);

  return null;
};

export default Analytics;